import { useEffect } from 'react';
import ProductPanel from './ProductPanel';
import SignUpSection from './SignUpSection';
import { useSignUpContext } from '../SignUpContext';
import './DirectSignUpPage.scss';

const DirectSignUpPage = () => {
    const { setIsDirectSignUpFlow } = useSignUpContext();

    useEffect(() => {
        setIsDirectSignUpFlow(true);
    }, [setIsDirectSignUpFlow]);

    return (
        <div className="DirectSignUp">
            <SignUpSection />
            <ProductPanel />
        </div>
    );
};

export default DirectSignUpPage;
